<template>
  <div>
  <header class="header">
      <UserInfo class="user-info-container" />
    </header>
  <main>
    <v-tabs v-model="tab" show-arrows centered>

      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">Profile</v-tab>
<!--      <v-tab href="#tab-2">Change Email</v-tab>-->
      <v-tab href="#tab-3">Password</v-tab>
      <v-tab href="#tab-4"  v-if="showTicketingLink === true">Link Client Reference</v-tab>
      <!--<v-tab href="#tab-5">Preferences</v-tab>-->
      <!--<v-tab href="#tab-5" >Membership &amp; Loyalty</v-tab>-->

      <v-tab-item :value="'tab-1'" :key="1">
        <div v-if="configValues.accountProfilePicturesAllowed === true">
        <UserProfileImage  />
        </div>
        <UserProfile />
      </v-tab-item>

<!--      <v-tab-item v-if="showPassword === true" :value="'tab-2'" :key="2">-->
<!--        <UserProfileChangeEmail />-->
<!--      </v-tab-item>-->

      <v-tab-item :value="'tab-3'" :key="3">
        <UserProfilePassword />
      </v-tab-item>

      <v-tab-item v-if="showTicketingLink === true" :value="'tab-4'" :key="4">
        <UserProfileTicketmasterLink />
      </v-tab-item>
      
      <v-tab-item :value="'tab-5'" :key="5">
        <UserProfileContactPrefs />
      </v-tab-item>

      <!--<v-tab-item :value="'tab-5'" :key="5">
        <UserProfileMembership />
        <UserProfileClientRefNo />
      </v-tab-item>-->
    </v-tabs>

    <FooterShout :type="'help'"/>
  </main>
</div>
</template>

<script>
  import UserProfile from '@/components/UserProfile'
  import UserProfilePassword from '@/components/UserProfilePassword'
  import UserProfileChangeEmail from '@/components/UserProfileChangeEmail'
  // import UserProfileClientRefNo from '@/components/UserProfileClientRefNo'
  import UserProfileImage from '@/components/UserProfileImage'
  //import UserProfileSeatgeekLink from '@/components/UserProfileSeatgeekLink'
  import UserProfileTicketmasterLink from '@/components/UserProfileTicketmasterLink'
  import UserProfileContactPrefs from '@/components/UserProfileContactPrefs'
  // import UserProfileMembership from '@/components/UserProfileMembership'
  import FooterShout from '@/components/FooterShout'
  import UserInfo from "@/components/UserInfo";

  export default {
    components: {
      UserProfile,
      UserProfileChangeEmail,
      UserProfilePassword,
      // UserProfileClientRefNo,
      UserProfileImage,
      //UserProfileSeatgeekLink,
      UserProfileTicketmasterLink,
      UserProfileContactPrefs,
      // UserProfileMembership,
      FooterShout,
      UserInfo
    },
    data () {
      return {
        showPassword: false,
        showMembership: false,
        showTicketingLink: false,
        tab: "tab-1"
      }
    },
    mounted () {
        console.log('User Profile component loaded')
        
        if(this.$getAuthenticatedUser() == null){
          console.log('User is not logged in')
          this.$router.push("/");
        } else {
          
          if(localStorage.loginFlow == "TicketMasterNoClientRef"){
            this.tab =  "tab-4"
          }
          // check to see if the user was created with traditional registration (and not Facebook or Google)
          this.$getCurrentUserAttributes().subscribe((userData) => {
            if(userData.email_verified){
              console.log('user allowed to change password')
              this.showPassword = true //if they did register with their email, then let them change password
            } 
            // Allow ticketing link tab to be seen if user is from approved organisation
            if(
              this.configValues.seatGeekAccountLinkingEnabled === true 
              && 
              (
                userData.email.includes('@urbanzoo.io') ||
                userData.email.includes('@'+this.configValues.clubRootDomain) ||
                userData.email.includes('@seatgeek.com')
              )
            ){ 
              this.showTicketingLink = false
            }
          })
        }
        console.log(this.$root.$data.referrer)

    }
  }
</script>
<style lang="scss" scoped>

.header {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 0;
  margin: 0 0 35px;
}


.header-strip {
  width: 100%;
  color: #fff;
  background-color: $primary-club;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 10px 25px 5px 25px;
}

.header-strip img {
  display: inline;
}

.header-strip h1 {
  display: inline;
  margin-left: 20px;
  font-size: 1.5em;
}

.user-info-container {
  margin: 20px 0 0;
}
@media screen and (min-width: 700px) {
  .header {
    flex-direction: row;
    justify-content: space-between;
    padding: 48px 100px 48px;
  }

  .user-info-container {
    top: 43px;
    left: 20px;
    margin: 0;
  }

  .button-home {
    display: block;
  }
}
@media screen and (min-width: 1200px) {
  .header {
    padding: 48px 300px 48px;
  }
}

  .theme--light.v-tabs__bar .v-tabs__div {
    color: $primary-club-light;
  }

</style>
